import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Backdrop,CircularProgress,TextField,Card,CardContent,Typography,Grid,Box,IconButton,Button } from '@mui/material';
import Swal from 'sweetalert2';
import { BASE_URL } from "../../App";
import axios from 'axios';

import PhoneIcon from '@mui/icons-material/Phone';
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BuildIcon from '@mui/icons-material/Build';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

export default function FieldPartner() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [MechanicMobileNo, setMechanicMobileNo] = useState(null);
  const [users, setusers] = useState(null);
  
	const USER_NAME = localStorage.getItem("USER_NAME");
	const USER_ID = localStorage.getItem("USER_ID");

  const handleEditClick = (user) => {
    //alert(`Edit button clicked for ${user.name}!`);
	navigate('/home/Dealer/Field_Partner_Add', {
		state: {
			MobileNo: user.MobileNo,
			Edit: 1,
		}
	});
  };


	useEffect(() => {
		ListLoading();
	}, []);
	
	const ListLoading = () => {
		setOpen(true);
        const data = { type: 'FieldPartnerListLoad', USER_ID: USER_ID }
        axios.post(BASE_URL + '/FieldPartner', data)
		.then(response => {
			setusers(response.data.message);
		}).catch(error => {
			Swal.fire({
				icon: "warning",
				text: `${error.response.data.message}`
			});
		}).finally(() => {
			setOpen(false);
		});
	};


  return (
    <>
      <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <div className="m-4">
        <Card sx={{ padding: 2 }}>
          <center><h5>Field Partner</h5></center>
          <br />
		  <div className="row">
			<div className="col-md-8">
				<TextField
					label="Mechanic Mobile Number"
					variant="outlined"
					size="small"
					fullWidth
					value={MechanicMobileNo}
					onChange={(e) => setMechanicMobileNo(e.target.value)}
					
				/>
			</div>
			<div className="col-md-4">
				<Button
				fullWidth
				variant="contained"
				startIcon={<AddCircleOutlineIcon />}
				onClick={()=>{
					if(MechanicMobileNo){
						navigate('/home/Dealer/Field_Partner_Add', {
							state: {
								MobileNo: MechanicMobileNo,
							}
						});
					}else{
						Swal.fire({
							icon: "info",
							text: 'Enter The Mobile Number.!!'
						});
						return false;
					}
				}}
				>
					<b>Add</b>
				</Button>
			</div>
		  </div>
          
          <hr />
          <center><h6>Existing Added Members</h6></center>
          {users && users.length > 0 ? (
			  (users.map((user) => (
			  <Card
				key={user.id}
				sx={{
				  maxWidth: 1450,
				  margin: '15px auto',
				  boxShadow: 8,
				  borderRadius: 3,
				  transition: 'transform 0.3s ease',
				  '&:hover': {
					transform: 'scale(1.01)',
				  },
				  backgroundColor: '#fdfdfd',
				}}
			  >
				<CardContent>
				  <Box
					display="flex"
					justifyContent="space-between"
					alignItems="center"
					borderBottom="1px solid #ddd"
					pb={1}
				  >
					<Typography variant="h6" fontWeight={500} color="primary">
					<PersonIcon color="primary" />{" "}
					  {user.Name}
					</Typography>
					<IconButton
					  onClick={() => handleEditClick(user)}
					  color="primary"
					  size="small"
					>
					  <EditIcon />{" "}Edit
					</IconButton>
				  </Box>

				  <div className="row">
					<div className="col-md-6">
					  <Box display="flex" alignItems="center" gap={1}>
						<PhoneIcon color="success" />
						<Typography fontWeight={400}>
						  <strong>Mobile:</strong> {user.MobileNo}
						</Typography>
					  </Box>
					</div>

					<div className="col-md-6">
					  <Box display="flex" alignItems="center" gap={1}>
						<HomeIcon color="warning" />
						<Typography fontWeight={400}>
						  <strong>Address:</strong> {user.Address}
						</Typography>
					  </Box>
					</div>

					<div className="col-md-6">
					  <Box display="flex" alignItems="center" gap={1}>
						<CheckCircleIcon color="info" />
						<Typography fontWeight={400}>
						  <strong>Status:</strong> {user.Status === "Active" ? <b className="text-success">{user.Status}</b> : <b className="text-danger">{user.Status}</b>}
						</Typography>
					  </Box>
					</div>

					<div className="col-md-6">
					  <Box display="flex" alignItems="center" gap={1}>
						<BuildIcon color="secondary" />
						<Typography fontWeight={400}>
						  <strong>Nature:</strong> {user.Nature}
						</Typography>
					  </Box>
					</div>
				  </div>
				</CardContent>
			  </Card>
			)))
			):(
				<center>No Data found.!</center>
			)}
        </Card>
      </div>
    </>
  );
}
